function cta_fixed_show() {

    if( document.querySelectorAll('.cta.fixed').length ) {
        const   cta = document.querySelector('.cta.fixed'),
                trigger_show = document.querySelector('.wp-block-button.primary'),
                trigger_hide = document.querySelector('.product_types');

        document.addEventListener('scroll', (event) => {
            let trigger_show_position = trigger_show.getBoundingClientRect(),
                trigger_hide_position = trigger_hide.getBoundingClientRect();
            // console.log(trigger_show_position);
            // console.log(trigger_hide_position);
            // console.log(window.innerHeight);
            if( trigger_show_position.top < 0 ) {
                cta.setAttribute('data-active', 1);

                if( trigger_hide_position.bottom < window.innerHeight ) {
                    cta.setAttribute('data-active', 0);
                }
            } else {
                cta.setAttribute('data-active', 0);
            }
        });      
        
    }

}

cta_fixed_show();